/* eslint-disable max-classes-per-file */
/**
 * Extends from built in Error() and now can accept api error response developers can now get the return status and status text.
 *
 * If err is not provided, statusCode and statusText will be null
 */

export class DHLError extends Error {
  constructor(message, err) {
    super(message);
    this.message = message;
    this.name = 'DHLError';
    this.statusCode = err?.response?.status ?? null;
    this.statusText = err?.response?.statusText ?? null;
    this.response = err?.response ?? null;
  }
}

/**
 * Custom error class for when OHI errors out.
 * @param {string} errorMessage - The error message to display.
 * @param {Array} messageList - An array of error messages returned by OHI.
 */
export class OHIError extends Error {
  constructor(errorMessage, messageList) {
    super(errorMessage);
    this.message = errorMessage;
    this.name = 'OHIError';
    this.messages = messageList ?? [];
  }
}

/**
 * Custom error class for when CRM errors out.
 * @param {string} message - The error message to display.
 */
export class CRMError extends Error {
  constructor(message) {
    super(message);
    this.message = message;
    this.name = 'CRMError';
  }
}

/**
 * Custom error class for when an invalid email is provided when sending an email quote from MP Change Product flow.
 * @param {string} message - The error message to display.
 */
export class InvalidEmailError extends CRMError {
  constructor(message) {
    super(message);
    this.name = 'InvalidEmailError';
  }
}

/**
 * Custom error class for a CreatePolicyError from EAI.
 */
export class CreatePolicyError extends Error {
  constructor(message, err) {
    super(message);
    this.message = message;
    this.name = 'CreatePolicyError';
    this.code = err?.code ?? null;
  }
}

export class CreatePolicyTimeoutError extends Error {
  constructor(message, err) {
    super(message);
    this.message = message;
    this.name = 'CreatePolicyTimeoutError';
    this.code = err?.code ?? null;
  }
}

/**
 * Custom error class for a SubmitPolicyError from EAI.
 */
export class SubmitPolicyError extends Error {
  constructor(message, err) {
    super(message);
    this.message = message;
    this.name = 'SubmitPolicyError';
    this.code = err?.code ?? null;
  }
}

export class SubmitPolicyInProcessError extends Error {
  constructor(message, err) {
    super(message);
    this.message = message;
    this.name = 'SubmitPolicyInProcessError';
    this.code = err?.code ?? null;
  }
}

export class SubmitPolicyTimeoutError extends Error {
  constructor(message, err) {
    super(message);
    this.message = message;
    this.name = 'SubmitPolicyTimeoutError';
    this.code = err?.code ?? null;
  }
}
